import { db } from '@/db/db';
import { newId, type Workout } from './model';
import { TEMPLATES } from './templates';

export async function listWorkouts(): Promise<Workout[]> {
  const own = (await db.workouts.toArray()).filter((w) => !w.deleted);
  own.sort((a, b) => b.updatedAt - a.updatedAt);
  return [...TEMPLATES, ...own];
}

export async function getWorkout(id: string): Promise<Workout | undefined> {
  return TEMPLATES.find((t) => t.id === id) ?? (await db.workouts.get(id));
}

export async function saveWorkout(w: Workout): Promise<Workout> {
  if (w.builtin) throw new Error('Vorlagen können nicht geändert werden – bitte duplizieren.');
  const next = { ...w, updatedAt: Date.now() };
  await db.workouts.put(next);
  return next;
}

export async function duplicateWorkout(w: Workout): Promise<Workout> {
  const copy: Workout = {
    ...structuredClone(w),
    id: newId('wo'),
    name: `${w.name} (Kopie)`,
    builtin: false,
    updatedAt: Date.now(),
  };
  // `special` is kept so a duplicated FTP test still produces an FTP proposal.
  await db.workouts.put(copy);
  return copy;
}

/** Soft delete (synced as a tombstone). */
export async function deleteWorkout(id: string): Promise<void> {
  const w = await db.workouts.get(id);
  if (w) await db.workouts.put({ ...w, deleted: true, updatedAt: Date.now() });
}
